import client from "../client"

export const updateMotibellViewCount = async ({ motibellNo }) => {
  const response = await client.put(`/motibells/${motibellNo}/viewings`)

  return response.data
}
